export default __webpack_public_path__ + "static/18-dd80a9b2b48cc1912a33a584d6cb708f.png";